import {
    Component,
    ElementRef,
    NgZone,
    ViewChild,
    Inject,
    Optional,
    OnInit,
    Output,
} from "@angular/core";
import {MatDialogRef, MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import { RoleService } from "app/main/services/roles.service";
import { TranslateService } from "@ngx-translate/core";

import {
    MatAutocompleteSelectedEvent,
    MatAutocomplete,
} from "@angular/material/autocomplete";
import { map, startWith } from "rxjs/operators";
import { CdkTextareaAutosize } from "@angular/cdk/text-field";
import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { MatChipInputEvent } from "@angular/material/chips";
import { MatSnackBar } from "@angular/material/snack-bar";
import { FormControl } from "@angular/forms";
import { Observable } from "rxjs";
import { SujetoObligado } from "app/main/models/sujeto-obligado.model";
import { TipoSujetoObligado } from "app/main/models/tipo-sujeto-obligado.model";
import { TipoDocumentoService } from "app/main/services/tipo-documento.service";
import { TipoSujetoObligadoService } from "app/main/services/tipo-sujeto-obligado.service";
import { TipoDocumento } from "app/main/models/tipo-documento.model";
import { PaisService } from "app/main/services/pais.service";
import { SectorActividadService } from "app/main/services/sector-actividad.service";
import { ProfesionService } from "app/main/services/profesion.service";
import { PersonaFisica } from "app/main/models/persona-fisica.model";
import { PersonaJuridica } from "app/main/models/persona-juridica.model";
import { Contacto } from "app/main/models/contacto.model";
import { Cliente } from "app/main/models/cliente.model";
import { ClienteGeneralData } from "app/main/models/cliente-general-data.model";
import { ClienteService } from "app/main/services/cliente.service";
import { DocumentoDeIdentidad } from "app/main/models/documento-de-identidad.model";
import { RazonSocial } from "app/main/models/razon-social.model";
import {LinkRelacionadoDialogBoxComponent} from './link-relacionado-dialog-box.component';
import { MatTooltipModule } from '@angular/material/tooltip';


@Component({
    selector: "cliente-dialog-box-antecedentes",
    templateUrl: "./dialog-box-antecedentes.component.html",
    styleUrls: ["./dialog-box-antecedentes.component.scss"],
})
export class ClienteDialogBoxAntecedentesComponent {
    LOCAL_DATA: any;
    displayedColumns: string[] = ["estructura", "nombre"];
    estadoModificado: boolean = false;

    constructor(
        public dialogRef: MatDialogRef<ClienteDialogBoxAntecedentesComponent>,
        public translate: TranslateService,
        public dialog: MatDialog,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: SujetoObligado
    ) {
        console.log(data);
        this.LOCAL_DATA = { ...data };
    }

    openDialog(): void {}

    closeDialog(): void {
        if(this.estadoModificado){
            this.dialogRef.close({ event: "Update", data: this.LOCAL_DATA});
        }else{
            this.dialogRef.close({ event: "Cancel" });
        }

    }

    openDialogEditarEstadoLink(): void {
        const dialogRef = this.dialog.open(
            LinkRelacionadoDialogBoxComponent,
            {
                width: "100%",
                data: this.LOCAL_DATA,
                disableClose: true,
            }
        );

        dialogRef.afterClosed().subscribe((result) => {
            if (result.event === "Update" && result.data != this.LOCAL_DATA.estado) {
                this.estadoModificado = true;
                this.LOCAL_DATA.estado = result.data;
            }
        });
    }

    //Obtener la respuesta y modificar el estado segun la respuesta

}
